import { useEffect } from 'react';
import { init } from 'emoji-mart';
import data from '@emoji-mart/data/sets/14/facebook.json';
import { useCustomEmojis } from '@/hooks/useCustomEmojis';
let emojiMartInitialized = false;

function initializeEmojiMart(customEmojis) {
  if (!emojiMartInitialized) {
    init({ data, custom: customEmojis });
    emojiMartInitialized = true;
  }
}

export function EmojiDisplay({ emoji, size = 20 }) {
  const { customEmojis, isLoading } = useCustomEmojis();

  useEffect(() => {
    if (!isLoading) {
      initializeEmojiMart(customEmojis);
    }
  }, [customEmojis, isLoading]);  
  
  if (!emoji) return null;
  
  return (
    <span style={{ 
      display: 'inline-flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      verticalAlign: 'middle',
      lineHeight: 0,
      transform: 'translateY(-1px)'
    }}>
      <em-emoji id={emoji} size={size} set="facebook"></em-emoji>
    </span>
  );
}

